import { useCallback } from 'react';
import { clarityService, ClarityEvent } from './ClarityService';

export interface UseClarityReturn {
  trackEvent: (eventName: ClarityEvent | string) => void;
  identifyUser: (userId: string) => void;
  clearUser: () => void;
  isEnabled: boolean;
  currentUser: string | null;
}

export const useClarity = (): UseClarityReturn => {
  const trackEvent = useCallback((eventName: ClarityEvent | string) => {
    clarityService.trackEvent(eventName);
  }, []);

  const identifyUser = useCallback((userId: string) => {
    clarityService.identifyUser(userId);
  }, []);

  const clearUser = useCallback(() => {
    clarityService.clearUser();
  }, []);

  return {
    trackEvent,
    identifyUser,
    clearUser,
    isEnabled: clarityService.isEnabled,
    currentUser: clarityService.currentUser
  };
};
